var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('formulario-datos',{on:{"guardado":_vm.volver}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }